<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-list-alt" class="q-mb-sm" /> {{ $t('tasks') }}
        </div>

        <div class="row gutter-sm">
            <div class="col-12">
                <q-input v-model="operator_name" :float-label="$t('representative')" autocomplete="new-password" :error="$v.operator.$error" @input="$v.operator.$touch" @clear="clearOperator" clearable>
                    <q-autocomplete
                        @search="getOperator"
                        :min-characters="3"
                        @selected="selectOperator"
                        :value-field="v => `${ v.label }`"
                        separator
                    />
                </q-input>
            </div>

            <div class="col-12">
                <q-datetime v-model="task_date" type="date" :float-label="$t('task_date')" format="DD/MM/YYYY" :error="$v.task_date.$error" @input="$v.task_date.$touch" />
            </div>
        </div>

        <q-table
            :data="task_steps"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-my-md"
            >

            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="secondary" icon="far fa-plus" :label="$t('new_f')" @click="showAddTask([])" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="branch_name" :props="props">
                    {{ props.row.branch_name }}
                </q-td>

                <q-td key="branch_address" :props="props">
                    {{ props.row.branch_address }}
                </q-td>

                <q-td key="collection" :props="props">
                    {{ getCollection(props.row.collection) }}
                </q-td>

                <q-td key="start_time" :props="props">
                    {{ props.row.start_time }}
                </q-td>

                <q-td key="end_time" :props="props">
                    {{ props.row.end_time }}
                </q-td>

                <q-td key="status" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatusList(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="far fa-pencil-alt" @click="showAddTask(props.row)" />
                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" />
                </q-td>
            </q-tr>
        </q-table>

        <div class="row gutter-sm justify-end q-mt-sm">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: '4traders_tasks' })" />
            </div>

            <div class="col-xs-12 col-sm-3">
                <q-btn color="positive" class="full-width" :label="$t('repeat')" icon="far fa-clock" @click="setRecurrence()" :disabled="disableRecurrence" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>

        <task :show_task="show_task" :task="task" :collections="collections" @hide_task="hideTask()" />

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>

        <q-modal v-model="confirm_recurrence" no-backdrop-dismiss no-esc-dismiss :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="confirm_recurrence = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('repeat') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-12">
                            <q-select v-model="recurring_type" :options="recurring_types" />
                        </div>

                        <div class="col-12" v-if="recurring_type != 'custom'">
                            <q-field :helper="$t('maximum_of_365')">
                                <q-input v-model="recurring_frequency" type="number" :prefix="$t('for')" :suffix="getInputSufix" />
                            </q-field>
                        </div>

                        <div class="col-12" v-if="recurring_type == 'custom'">
                            <q-btn color="positive" class="full-width" :label="$t('add_date')" icon="fal fa-plus" @click="addDate()" />
                        </div>

                        <div class="col-12" v-if="recurring_type == 'custom'">
                            <q-datetime v-for="(item, index) in recurring_frequency_custom" v-model="item.date" type="date" clearable @clear="removeDate(index)" format="DD/MM/YYYY" :error="error_recurring_frequency_custom" :key="index" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-sm">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-chevron-left" @click="confirm_recurrence = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="confirmRecurrence()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="confirm_edit_recurring" @ok="confirmRecurrence">
            <span slot="title">{{ $t('edit_recurrence') }}</span>

            <div slot="body">
                <q-field>
                    <q-select v-model="type_edit_recurring" :options="types_edit_recurring" />
                </q-field>
            </div>

            <template slot="buttons" slot-scope="props">
                <q-btn color="tertiary" :label="$t('cancel')" @click="confirm_edit_recurring = false" />
                <q-btn color="secondary" :label="$t('save')" @click="confirmEditRecurrence()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Task from 'components/admin/4traders/Task'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    i18nOptions: { namespaces: ['common', 'fortraders'] },

    components: {
        'task': Task
    },

    data() {
        return {
            id: '',
            operator: '',
            operator_name: '',
            recurring_code: '',
            task_date: '',
            task_steps: [],
            collections: [],
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'name',
                    sortable: false,
                },
                {
                    name: 'branch_name',
                    required: true,
                    label: 'branch',
                    align: 'left',
                    field: 'branch_name',
                    sortable: false,
                },
                {
                    name: 'branch_address',
                    required: true,
                    label: 'address',
                    align: 'left',
                    field: 'branch_address',
                    sortable: false,
                },
                {
                    name: 'collection',
                    required: true,
                    label: 'tasks',
                    align: 'left',
                    field: 'collection',
                    sortable: false,
                },
                {
                    name: 'start_time',
                    required: true,
                    label: 'start_time',
                    align: 'left',
                    field: 'start_time',
                    sortable: false,
                },
                {
                    name: 'end_time',
                    required: true,
                    label: 'end_time',
                    align: 'left',
                    field: 'end_time',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            loading: false,
            show_task: false,
            task: {},
            confirm_remove: false,
            action_id: '',
            confirm_recurrence: false,
            recurring_type: 'daily',
            recurring_types: [
                { value: 'daily', label: this.$t('daily') },
                { value: 'weekly', label: this.$t('weekly') },
                { value: 'monthly', label: this.$t('monthly') },
                { value: 'custom', label: this.$t('custom') },
            ],
            recurring_frequency: '',
            recurring_frequency_custom: [],
            error_recurring_frequency_custom: false,
            confirm_edit_recurring: false,
            type_edit_recurring: 1,
            types_edit_recurring: [
                { value: 1, label: this.$t('all_next_recurrences') },
                { value: 2, label: this.$t('only_this_recurrences') }
            ],
            item: {}
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            profile_list: 'registration_lists/profiles',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },

        disableRecurrence() {
            if (this.recurring_code || !this.id) return true
            else return false
        },

        getInputSufix() {
            if (this.recurring_type === 'daily') {
                return this.$t('days')
            }
            else if (this.recurring_type === 'weekly') {
                return this.$t('weeks')
            }
            else if (this.recurring_type === 'monthly') {
                return this.$t('months')
            }
            else return ''
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        fetchLists() {
            this.$q.loading.show()

            this.$axios.all([this.fetchCollections()])
            .then(this.$axios.spread((collections) => {
                this.collections = []

                collections.data.forEach(collection => {
                    this.collections.push({ value: collection.id, label: collection.title })
                })

                if (this.id != 0) {
                    this.fetchData()
                    this.request({pagination: this.server_pagination})
                }
                else {
                    this.$q.loading.hide()
                }
            }))
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        fetchCollections() {
            return this.$axios.get('/admin_tasks/tasks/list_collections/', this.getHeader)
        },

        fetchData() {
            this.$axios.get(`/admin_tasks/tasks/${this.id}/`, this.getHeader)
            .then(response => {
                this.operator = response.data.operator
                this.operator_name = response.data.operator_name
                this.task_date = response.data.task_date ? moment(response.data.task_date).tz('Etc/GMT').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
                this.recurring_code = response.data.recurring_code
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            this.$axios.get(`/admin_tasks/tasks/${this.id}/task_steps/`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.task_steps = []
                response.data.forEach(result => {
                    this.task_steps.push({
                        branch: result.branch,
                        branch_address: result.branch_address,
                        branch_company: result.branch_company,
                        branch_document: result.branch_document,
                        branch_lat: result.branch_lat,
                        branch_long: result.branch_long,
                        branch_name: result.branch_name,
                        collection: result.collection,
                        observation_request: result.observation_request,
                        id: result.id,
                        status: result.status,
                        start_time: result.start_time,
                        end_time: result.end_time,
                        actions: result.id
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('operator', this.operator)
                fd.append('task_date', this.task_date ? date.formatDate(this.task_date, 'YYYY-MM-DD') : '')

                if (this.id != 0 && !this.recurring_code) {
                    this.$axios.put(`/admin_tasks/tasks/${this.id}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('task_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$router.push({ name: '4traders_tasks' })
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        if (e.response.status == 406) {
                            this.$q.notify({
                                message: this.$t('the_operator_already_has_events_for_the_selected_day'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }
                        else {
                            this.$q.notify({
                                message: this.$t('task_save_error'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }

                        console.log(e)
                    })
                }
                else if (this.id != 0 && this.recurring_code) {
                    this.$q.loading.hide()
                    this.confirm_edit_recurring = true
                }
                else {
                    this.$axios.post(`/admin_tasks/tasks/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('task_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.id = response.data.id
                        this.$router.push({ name: '4traders_task', params: { id: response.data.id } })
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        if (e.response.status == 406) {
                            this.$q.notify({
                                message: this.$t('the_operator_already_has_events_for_the_selected_day'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }
                        else {
                            this.$q.notify({
                                message: this.$t('task_save_error'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }

                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        confirmEditRecurrence() {
            this.$q.loading.show()

            let fd = new FormData()
            fd.append('operator', this.operator)
            fd.append('task_date', this.task_date ? date.formatDate(this.task_date, 'YYYY-MM-DD') : '')

            if (this.type_edit_recurring === 1) {
                fd.append('recurring_code', this.recurring_code)
            }

            this.$axios.put(`/admin_tasks/tasks/${this.id}/`, fd, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.$q.notify({
                    message: this.$t('task_save_success'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })

                this.$router.push({ name: '4traders_tasks' })
            })
            .catch(e => {
                this.$q.loading.hide()

                console.log(e.response.status)

                this.$q.notify({
                    message: this.$t('task_save_error'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })

                console.log(e)
            })
        },

        setRecurrence() {
            if (!this.recurring_code) this.confirm_recurrence = true
        },

        confirmRecurrence() {
            if (this.recurring_type && (this.recurring_frequency || this.recurring_frequency_custom.length > 0) && this.recurring_frequency < 365) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('recurring_type', this.recurring_type)

                if (this.recurring_type != 'custom') {
                    fd.append('recurring_frequency', this.recurring_frequency)
                }
                else {
                    this.recurring_frequency_custom.forEach(element => {
                        if (element.date) fd.append('recurring_frequency', date.formatDate(element.date, 'YYYY-MM-DD'))
                    })
                }

                this.$axios.post(`/admin_tasks/tasks/${this.id}/set_task_recurring/`, fd, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('cannot_create_recurrence_user_already_has_events_for_the_day'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })

                    this.id = response.data.id
                    this.$router.push({ name: '4traders_tasks' })
                })
                .catch(e => {
                    this.$q.loading.hide()

                    if (e.response.status == 406) {
                        this.$q.notify({
                            message: this.$t('cannot_create_recurrence_user_already_has_events_for_the_day'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                    }
                    else {
                        this.$q.notify({
                            message: this.$t('task_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                    }

                    console.log(e)
                })
            }
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_tasks/tasks/${this.id}/task_steps/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        getOperator(terms, done) {
            this.$axios.get(`/admin_tasks/tasks/get_task_operators/?search=${terms}`, this.getHeader)
            .then(response => {
                let representatives = []

                response.data.forEach(element => {
                    representatives.push({ value: element.id, label: `${element.full_name}` })
                })
                done(representatives)
            })
        },

        selectOperator(item) {
            this.item = item
            this.operator = item.value
            this.operator_name = item.label
        },

        clearOperator() {
            this.operator = ''
            this.operator_name = ''
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getStatus(status) {
            if (status == 1) return 'pending'
            else if (status == 2) return 'realized'
            else if (status == 3) return 'deleted'
            else if (status == 4) return 'canceled'
            else if (status == 5) return 'in_progress'
            else if (status == 6) return 'questions_sent'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-clock'
            else if (status == 2) return 'fas fa-check-double'
            else if (status == 3) return 'fas fa-trash-alt'
            else if (status == 4) return 'fas fa-ban'
            else if (status == 5) return 'fas fa-spinner'
            else if (status == 6) return 'fas fa-check'
        },

        getColorStatusList(status) {
            if (status == 1) return 'warning'
            else if (status == 2) return 'positive'
            else if (status == 3) return 'negative'
            else if (status == 4) return 'faded'
            else if (status == 5) return 'info'
            else if (status == 6) return 'info'
        },

        getCollection(id) {
            let obj = this.collections.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        showAddTask(task) {
            this.task = task

            if (this.$route.params.id != 0) {
                this.show_task = true
            }
            else {
                this.$v.$touch()

                if (!this.$v.$error) {
                    this.$q.loading.show()

                    let fd = new FormData()
                    fd.append('operator', this.operator)
                    fd.append('task_date', this.task_date ? date.formatDate(this.task_date, 'YYYY-MM-DD') : '')

                    this.$axios.post(`/admin_tasks/tasks/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('task_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.id = response.data.id
                        this.$router.push({ name: '4traders_task', params: { id: response.data.id } })

                        if (this.$route.params.id != 0) {
                            this.show_task = true
                        }
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        if (e.response.status == 406) {
                            this.$q.notify({
                                message: this.$t('the_operator_already_has_events_for_the_selected_day'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }
                        else {
                            this.$q.notify({
                                message: this.$t('task_save_error'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }

                        console.log(e)
                    })
                }
                else{
                    this.$q.notify({
                        message: this.$t('make_sure_that_all_fields_are_filled_in'),
                        type: 'negative',
                        icon: 'fal fa-exclamation-triangle',
                        position: 'top'
                    })
                }
            }
        },

        hideTask() {
            this.show_task = false
            this.task = {}
            this.request({
                pagination: this.server_pagination
            })
        },

        addDate() {
            this.recurring_frequency_custom.push({ date: null })
        },

        removeDate(index) {
            this.recurring_frequency_custom.splice(index, 1)
        }
    },

    created() {
        this.id = this.$route.params.id
        this.fetchLists()
    },

    validations() {
        return {
            operator: { required },
            task_date: { required },
            recurring_type: { required }
        }
    }
}
</script>

<style>

</style>
